module.exports = __webpack_public_path__ + "static/img/on-2p.814e396.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newHome/village/on-2p.png
// module id = aGmv
// module chunks = 1